export function view(action, is_new_generate_letters_enabled) {
  if (action.id === 'letter' && action.document_id) {
    return 'LetterPredefined'
  } else if (action.id === 'letter' && !action.document_id) {
    return is_new_generate_letters_enabled ? 'LetterNew' : 'LetterNewOld'
  } else {
    return 'No'
  }
}
